import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "api/callApi";
import { Button, Loader } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import { Checkbox } from "antd";
import { ProjectDropdown } from "components";
import theme from "theme";
import SC from "./style";
import UserTable from "views/AdminSettings/Users/UserTable";
import { innoTableConfigsecond } from "utils/config";
import { showAlert } from "utils/helper";

function AssignUser(props) {
  const {
    onClose = () => {},
    userdata = [],
    fetchData = () => {},
    project = null,
    closeOnSave = false,
    isDisabled = false,
    hideColumns = ["cell", "userType", "createdAt"],
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [assignedProjectUserIds, setAssignedProjectUserIds] = useState([]);
  const [rootLibraryUsers, setRootLibraryUsers] = useState([]);
  const [currentProject, setCurrentProject] = useState(project?.id || null);
  const [currentPageP, setCurrentPageP] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [selectedOnly, setSelectedOnly] = useState(false);
  const [selectedOnlyRefreshKey, setSelectedOnlyRefreshKey] = useState(0);

  useEffect(() => {
    const projectId = project?.id || null;
    setCurrentProject(projectId);
    if (projectId) {
      getprojectAssignUser(projectId);
    }
  }, [project]);

  const handleProjectChange = (selectedProject) => {
    setCurrentProject(selectedProject);
    getprojectAssignUser(selectedProject);
  };

  const getprojectAssignUser = async (projectId) => {
    if (!projectId) {
      setSelectedItems([]);
      setAssignedProjectUserIds([]);
      return;
    }
    try {
      setLoading(true);
      const response = await apiGet(`/v1/assignproject/${projectId}`, false);
      const assignuser = response.data.map((user) => user.userId);
      const rootUsers = response.data
        .filter((user) => user.rootLibraryAccess == 1)
        .map((user) => user.userId);
      setSelectedItems(assignuser);
      setAssignedProjectUserIds(assignuser);
      setRootLibraryUsers(rootUsers);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const manageAssignProjectUser = async () => {
    if (!currentProject) {
      showAlert({
        title: "Please select a property",
        text: "You need to choose a project first",
        icon: "warning",
      });

      return;
    }

    try {
      setLoading(true);
      const response = await apiPost(`/v1/assignproject/${currentProject}`, {
        users: selectedItems,
        rootLibraryUsers,
      });
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      await getprojectAssignUser(currentProject);
      setSelectedOnlyRefreshKey((prevKey) => prevKey + 1);
      if (closeOnSave) {
        onClose();
      }
    } catch (error) {
      console.log("error", error);
      showAlert({
        title: "Error",
        text: error?.response.data.message,
        icon: "error",
      });
      setLoading(false);
    }
  };

  const getAllUser = async () => {
    try {
      setLoading(true);
      const response = await apiGet(`/v1/getallusers`, false);
      console.log(response.data);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllUser();
    if (currentProject) {
      getprojectAssignUser(currentProject);
    }
  }, []);

  useEffect(() => {
    setRootLibraryUsers((prevRootUsers) =>
      prevRootUsers.filter((id) => selectedItems.includes(id)),
    );
  }, [selectedItems]);

  const onSelectionChange = (id, selectAll = false) => {
    if (!currentProject) {
      showAlert({
        title: "Please select a property",
        text: "You need to choose a project first",
        icon: "warning",
      });
      return;
    }

    if (id === "clear") {
      setSelectedItems([]);
      setRootLibraryUsers([]);
      return;
    }

    const availableRoleIds = data.map((item) => item.id);
    setSelectedItems((prevSelectedItems) => {
      if (selectAll) {
        return availableRoleIds;
      }

      const isValidRole = availableRoleIds.includes(id);
      if (!isValidRole) {
        console.warn("Invalid Role ID:", id);
        return prevSelectedItems;
      }

      const updatedSelectedItems = prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((item) => item !== id)
        : [...prevSelectedItems, id];

      const validSelectedItems = updatedSelectedItems.filter((item) =>
        availableRoleIds.includes(item),
      );
      setRootLibraryUsers((prevRootUsers) =>
        prevRootUsers.filter((item) => validSelectedItems.includes(item)),
      );
      return validSelectedItems;
    });
  };

  const handleRootLibraryChange = (userId, checked) => {
    setRootLibraryUsers((prevRootUsers) => {
      if (checked) {
        return prevRootUsers.includes(userId)
          ? prevRootUsers
          : [...prevRootUsers, userId];
      }
      return prevRootUsers.filter((id) => id !== userId);
    });
  };

  const tableConfig = {
    draggable: false,
    selection: true,
    expandable: true,
    addNew: true,
    search: true,
    action: false,
    sno: false,
    divBorder: true,
    pagination: false,
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>Assign Users to Project </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {loading && <Loader />}

      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ProjectDropdown
          defaultValue={currentProject}
          onChange={handleProjectChange}
          disabledDropdown={isDisabled}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <Checkbox
            checked={selectedOnly}
            onChange={(event) => {
              const checked = event.target.checked;
              setSelectedOnly(checked);
              if (checked) {
                setSelectedItems((prevSelectedItems) => [
                  ...new Set([...assignedProjectUserIds, ...prevSelectedItems]),
                ]);
              }
            }}
            style={{ alignSelf: "center", fontSize: "12px" }}
          >
            Assigned User
          </Checkbox>
          <Button
            caption="Cancel"
            fontSize="12px"
            style={{
              background: "#f7f9f7",
              color: theme.colors.white,
              minWidth: "100px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
            onClick={onClose}
          />
          <Button
            caption={"Save"}
            type="submit"
            isLoading={loading}
            onClick={manageAssignProjectUser}
            color="white"
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "100px",
              height: "30px",
              borderRadius: "3px",
            }}
            disabled={data.length == 0}
          />
        </div>
      </div>
      <div>
        <UserTable
          tableConfig={tableConfig}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          userProjectId={currentProject}
          //hideColumns={["cell", "userType", "createdAt"]}
          hideColumns={hideColumns}
          allowEdit={true}
          currentPageP={currentPageP}
          setTotalData={setTotalData}
          isDisabled={isDisabled}
          selectedOnly={selectedOnly}
          selectedUserIds={assignedProjectUserIds}
          selectedOnlyRefreshKey={selectedOnlyRefreshKey}
        />
      </div>
    </>
  );
}

export default AssignUser;
